import { useTranslation } from 'react-i18next';
import styles from "../styles/components/Modes.module.css";
import icon1 from '../assets/images/icon1.png';
import icon2 from '../assets/images/icon2.png';
import icon3 from '../assets/images/icon3.png';


function Modes() {
  const { t } = useTranslation();

  return (
    <section className={styles.modes}>
      <div className={`${styles.mode} ${styles.blank} ${styles.offset}`}>
        <img src={icon1} alt="Icon 1" className={styles.icon} />
        <div className={styles.content}>
          <h3>{t('modes.title1')}</h3>
          <p>{t('modes.desc1')}</p>
        </div>
      </div>

      <div className={`${styles.mode} ${styles.hints}`}>
        <img src={icon2} alt="Icon 2" className={styles.icon} />
        <h3>{t('modes.title2')}</h3>
        <p>{t('modes.desc2')}</p>
      </div>

      <div className={`${styles.mode} ${styles.scenarios} ${styles.offset}`}>
        <img src={icon3} alt="Icon 3" className={styles.icon} />
        <div className={styles.content}>
          <h3>{t('modes.title3')}</h3>
          <p>{t('modes.desc3')}</p>
        </div>
      </div>
    </section>
  );
}

export default Modes;
